<template>
  <div class="prodSlider-front main-page-review-items">
    <div class="container" ref="main">
      <div class="top-row">
        <div id='app-slider'>
          <div class='slider js-slider'>
            <div class="row">
              <div class="">
                <div class="slider__body" v-bind:style='{left: sliderOffsetLeft + "px"}'>
                  <div v-for="item in data"
                       v-if="Object.keys(data).length > 0"
                       class="client-review-item slider__slide js-slide"
                       :style="{minWidth: blockWidth + 'px'}">
                      <div class="position-relative">
<!--                        <div class="img">-->
<!--                          <img :src="item.images.origin.src" alt="">-->
<!--                        </div>-->
                        <div class="rev-block">
                          <div class="name">{{item.name}}</div>
<!--                          <div class="work">{{item.position}}</div>-->
                          <div class="text" v-html="item.text"></div>
                        </div>
                      </div>
                  </div>
                  <i v-else-if="loading" class="fa fa-spinner fa-spin fa-3x fa-fw text-success"
                     style="font-size: 15px;"></i>
                  <p v-else class="text-center m-0 py-4">{{ Lang.get('js.products.empty') }}</p>
                  <div v-if="sliderList" class="slider__slide js-slide" v-for='slide in sliderList'></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="slider-navigation" v-if="Object.keys(data).length > 0">
        <div class="arrows">
          <div class="arrow ar-left" @click='prevSlide'></div>
          <div class="arrow ar-right" @click='nextSlide'></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Blazy from 'blazy';

    export default {
        name: 'client-review-slider',
        props: {
          slides: {
              required: true
          }
        },
        data() {
            return {
                data: [],
                loading: false,
                Lang,
                previewCount: 0,
                sliderAllCount: 0,
                // Номер активного слайда
                sliderActive: 1,
                // Отступ тела со слайдами в контейнере
                sliderOffsetLeft: 0,
                // Шаг одного слайда = его длина
                sliderOffsetStep: 0,
                containerWidth: 0,
                // Список изображений
                // sliderList: [],
                sliderList: [
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                    {item: ''},
                ]
            }
        },
        computed: {
            blockWidth() {
                if (document.documentElement.clientWidth < 768) {
                    return this.containerWidth;
                } else if (document.documentElement.clientWidth >= 768 && document.documentElement.clientWidth < 992) {
                    return (this.containerWidth - 30) / 2;
                } else {
                    return this.containerWidth / 3;
                }

            },
        },
        methods: {
            getClientReviewData() {
                this.loading = true;
                    this.data = this.slides;
                    this.loading = false;
                    this.previewCount = this.data.length;
                    setTimeout(function () {
                        let bLazy = new Blazy();
                    }, 100);
            },
            // Иницилизация слайдера
            initSlider: function () {
                // Получаем элементы сладера и его слайдов
                let sliderBody = this.$el.querySelector('.js-slider');

                let sliderSlidies = sliderBody.querySelectorAll('.js-slide');
                // Записываем длину одного слайда для перелистывания
                this.sliderOffsetStep = sliderBody.clientWidth;
                // Общее количество слайдов для стопов
                this.sliderAllCount = sliderSlidies.length;
            },

            // Открыть слайд по номеру
            openSlide: function (id) {
                if (id > 0 && id <= this.sliderAllCount) {
                    this.sliderActive = id;
                    this.sliderOffsetStep = this.blockWidth;
                    
                    // Сдвигаем элемент со слайдами
                    this.sliderOffsetLeft = -(this.sliderActive * this.sliderOffsetStep - this.sliderOffsetStep);
                }
            },

            // Следующий слайд
            nextSlide: function () {
                let count;
                if (document.documentElement.clientWidth < 768) {
                    count = 1;
                } else {
                    count = 3;
                }
                if (this.sliderActive < this.sliderAllCount && this.sliderActive <= this.previewCount - count) {
                    this.sliderActive += 1;
                    this.openSlide(this.sliderActive);
                } else {
                    this.sliderActive = 1;
                    this.openSlide(this.sliderActive);
                }
            },

            // Предыдущий слайд
            prevSlide: function () {
                if (this.sliderActive > 1) {
                    this.sliderActive -= 1;
                    this.openSlide(this.sliderActive)
                }
            },
        },
        mounted() {
            this.getClientReviewData();
            // if(this.data.length > 0) {
            this.containerWidth = this.$refs.main.clientWidth;
            this.initSlider();
            // }
        }
    }
</script>

<style scoped>
  .slider__slide {
    min-width: 100%;
    height: 100%;
    overflow: hidden;
    -webkit-box-flex: 1;
    -ms-flex: 1 100%;
    flex: 1 100%;
    border-radius: 12px;
  }
  
  .slider__body {
    min-width: auto;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
  }

</style>



// WEBPACK FOOTER //
// resources/js/components/elements/ClientReviewSlider.vue